var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Practice/PracticeConnection/index.tsx";
import React, { useState } from 'react';
import { Divider, LoadingSpinner, Stack, Text, VStack } from '@adc/parallax-component-library';
import { useApiError, useLibrePractice, useToast } from 'Hooks';
import { Link, Main, TitleActionBar } from 'Components/utility';
import { applyPhoneNumberMask } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const PracticeConnection = ({
  data: {
    practiceConnection
  }
}) => {
  const [footerLoading, setFooterLoading] = useState(false);
  const {
    removePractice,
    showStopSharingModal
  } = useLibrePractice();
  const {
    showToast
  } = useToast();
  const {
    showApiErrorModal
  } = useApiError();
  if (!practiceConnection) {
    mediator.publish('router:navigate', '/connections');
    return null;
  }
  const onStopSharing = () => {
    showStopSharingModal(async () => {
      try {
        setFooterLoading(true);
        await removePractice(practiceConnection.practiceId);
        showToast({
          message: i18n.t('Connections.modals.practiceRemovedToast.body'),
          'aria-label': i18n.t('Connections.modals.practiceRemovedToast.body'),
          icon: undefined
        });
        mediator.publish('router:navigate', '/connections');
      } catch {
        showApiErrorModal();
      } finally {
        setFooterLoading(false);
      }
    });
  };
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "PracticeConnection",
    title: practiceConnection.name,
    onBack: () => {
      mediator.publish('router:navigate', '/connections');
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.title",
    color: "$text.100",
    fontWeight: "$h4.strong",
    fontSize: "$h4.strong",
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.connectedPractice.primaryText')), /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.secondaryText",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    color: "$text.100",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.connectedPractice.secondaryText')), /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.practiceID.label",
    color: "$text.60",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    marginBottom: "$0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.connectedPractice.formField.practiceID.label')), /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.practiceID",
    color: "$text.100",
    fontSize: "$bodyBase.medium",
    fontWeight: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 11
    }
  }, practiceConnection.businessId), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.practiceAddress.label",
    color: "$text.60",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    marginBottom: "$0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.connectedPractice.formField.practiceAddress.label')), /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.practiceAddress",
    color: "$text.100",
    fontSize: "$bodyBase.medium",
    fontWeight: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 11
    }
  }, `${practiceConnection.address1}, ${practiceConnection.city}, ${practiceConnection.state} ${practiceConnection.zip}`), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.practicePhoneNumber.label",
    color: "$text.60",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    marginBottom: "$0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.connectedPractice.formField.practicePhoneNumber.label')), /*#__PURE__*/React.createElement(Text, {
    testID: "PracticeConnection.practicePhoneNumber",
    color: "$text.100",
    fontSize: "$bodyBase.medium",
    fontWeight: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 11
    }
  }, applyPhoneNumberMask(practiceConnection.phoneNumber)), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 11
    }
  }), footerLoading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 15
    }
  })) : /*#__PURE__*/React.createElement(Link, {
    testID: "PracticeConnection.stopSharing-btn",
    onPress: onStopSharing,
    linkTextColor: "$support.danger.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 13
    }
  }, i18n.t('Connections.content.connectedPractice.bodyText')))));
};
export default PracticeConnection;